module.exports = __webpack_public_path__ + "img/zanwu.ba6c8868.png";